import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

import "./DetailsLayout.css";
import { ROUTES } from "../../data";

export default function DetailsLayout({ children, subtitle }) {
  const navigate = useNavigate();
  const titleRef = useRef(null);

  useEffect(() => {
    titleRef.current.focus();
  }, []);

  const handleOnBack = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <div className="details-layout-container">
      <div
        className="details-layout-header"
        onClick={handleOnBack}
        ref={titleRef}
        tabIndex={-1}
      >
        <FaArrowLeftLong className="details-layout-left-icon" />
        <span className="details-layout-title">Home</span>
      </div>
      <span className="details-layout-subtitle">{subtitle}</span>
      {children}
    </div>
  );
}
